import styled from 'styled-components'
// Styled component for Timer component
/* --------------------------------------------- */
export const TimerContainer = styled.div`
  color: ${({ metaTheme: { body } }) => body && body.text.tertiary};
  background: ${({ metaTheme: { body } }) => body && body.background.tertiary};
  border-radius: 5px;
`
